"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Info = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Info = function (_a) {
    var channel = _a.channel;
    return react_1.default.createElement("div", { className: 'storybook-subscription-info' },
        react_1.default.createElement(storybook_1.Texts.Heading, { className: 'mb-xs font-bold' },
            channel.label,
            " channel abonnement"),
        react_1.default.createElement("p", { className: 'mb-md md:mr-xs' }, "Je staat op het punt een Eyecons channel abonnement af te sluiten, dit kan je doen op jaar- of maandbasis."),
        react_1.default.createElement("p", null,
            channel.label,
            " bepaalt zelf de inhoud en prijs van dit abonnement. Voor meer informatie ga naar: ",
            react_1.default.createElement(storybook_1.Texts.Link, { target: '_blank', href: 'https://eyecons.zendesk.com' }, "Eyecons.zendesk.com")));
};
exports.Info = Info;
exports.Info.propTypes = {
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        label: prop_types_1.default.string.isRequired
    }).isRequired,
};
